import {
  PartneAdminPath,
  PartnerHomePath,
  PartnerNotificationPath,
  PartnerOrderManagePath,
  PartnerOrderPath,
  PartnerQuotePath,
} from "@/common/enum/path";
import { PartnerGlobalPanel } from "@/components/panel/PartnerGlobalPanel";
import PartnerNoticePage from "@/page/notification/PartnerNoticePage";
import { PartnerCompleteOrderPage } from "@/page/order/PartnerCompleteOrderPage";
import PartnerCreateOrderPage from "@/page/order/PartnerCreateOrder/page";
import { PartnerManageOrderPage } from "@/page/order/PartnerManageOrderPage";
import PartnerOrderDetailPage from "@/page/order/PartnerOrderDetailPage";
import { PartnerOrderPage } from "@/page/order/PartnerOrderPage";
import { PartnerHomePage } from "@/page/partner/PartnerHomePage";
import PartnerQuoteDetailPage from "@/page/quote/PartnerDetail/PartnerQuoteDetailPage";
import { PartnerQuotePage } from "@/page/quote/PartnerQuotePage";
import { Navigate, Route, Routes } from "react-router-dom";
import PartnerMyProfilePage from "../page/partner/PartnerMyProfilePage";

export const PartnerMainRouter = () => {
  return (
    <>
      <Routes>
        <Route
          path={PartneAdminPath.MY_PROFILE}
          element={<PartnerMyProfilePage />}
        />
        <Route
          path={PartnerNotificationPath.NOTICE}
          element={<PartnerNoticePage />}
        />
        <Route path={PartnerOrderPath.ORDER} element={<PartnerOrderPage />} />
        <Route
          path={PartnerOrderPath.CREATE_ORDER}
          element={<PartnerCreateOrderPage />}
        />
        <Route
          path={PartnerOrderPath.COMPLETE_ORDER}
          element={<PartnerCompleteOrderPage />}
        />
        <Route
          path={PartnerOrderManagePath.MANAGE_ORDER}
          element={<PartnerManageOrderPage />}
        />
        <Route
          path={PartnerOrderManagePath.ORDER_DETAIL}
          element={<PartnerOrderDetailPage />}
        />
        <Route path={PartnerHomePath.HOME} element={<PartnerHomePage />} />
        <Route path={PartnerQuotePath.QUOTES} element={<PartnerQuotePage />} />
        <Route
          path={PartnerQuotePath.QUOTES_DETAIL}
          element={<PartnerQuoteDetailPage />}
        />

        <Route path="*" element={<Navigate to={"/"} />} />
      </Routes>
      <PartnerGlobalPanel />
    </>
  );
};
